import { Checkbox } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

import React, { useState, useEffect } from "react";
import { CapitalPlanService } from "../../../services/CapitalPlanService";
import { useAppSelector, useAppDispatch } from "../../../redux/hooks";
import {
  CapitalProject,
  getCapitalProjects,
} from "../../../redux/slices/capitalProjectsSlice";
import {
  getCapitalPlanTableData,
  CapitalPlanTableData,
} from "../../../redux/slices/capitalPlanTableSlice";


import Skeleton from "@mui/material/Skeleton";
import { GenericToast } from "../../util/ToastMessage";
import { currency, numberWithComma } from "../../util/valueFormatter";
import { CommentKey } from "constant";
import { postApiCall } from "services/apiHelper";
import { baseUrl } from "config/config";

interface RowWiseData {
  [key: string]: Array<string | number | number | number | number | number>;
}

const label = { inputProps: { "aria-label": "Checkbox demo" } };
export const CapitalPlanDisplayForm = () => {
  const rowWiseData: RowWiseData = {};
  const dispatch = useAppDispatch();

  const assetPlanId = useAppSelector(
    (state) => state.getAssetPlanId.assetPlanId
  );
  const budgetYear = Number(
    useAppSelector((state) => state.summary.dapData?.budgetYear)
  );

  const capitalPlanTableData: CapitalPlanTableData[] = useAppSelector(
    (state) => state.capitalPlanTable.capitalPlan
  );
  const capitalPlanTableDataStatus = useAppSelector(
    (state) => state.capitalPlanTable
  );
  //const assetPlanId: string = "c592630a-c679-4b9c-b72e-eac417743b17";
  // const [capitalProjectData, setCapitalProjectData] = useState<
  //   capitalProject[]
  // >([]);
  const capitalProjectData: CapitalProject[] = useAppSelector(
    (state) => state.capitalProjects.data
  );
  const isNoData: boolean = useAppSelector(
    (state) => state.capitalProjects.isNoData
  );

  const [yearRangeSelected, setYearRangeSelected] = useState<number>(1);
  const [glAccounts, setGlaccounts] = useState<any>();
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({ 'Turn Costs': true });
  const capitalPlanService = new CapitalPlanService();
  const dapData: any = useAppSelector((state) => state.summary.dapData);
  const columns: string[] = [
    "year",
    "biCapital",
    "leasingCostCommercial",
    "turnCostResidential",
    "totalCapital",
  ];
  const CPColumnNameArray: string[] = [
    "BI Capital",
    "Leasing Cost (Commercial)",
    "Turn Cost (Residential)",
    "Total Capital",
    "Projected NOI 2023",
  ];

  const columnNames: string[] = [
    //change the year from the elements of array with year which is comming from redux store.
    `${budgetYear} Capital`,
    `% of ${budgetYear} NOI`,
    `${budgetYear + 1} Capital`,
    `${budgetYear + 2} Capital`,
    `${budgetYear + 3} Capital`,
    `${budgetYear + 4} Capital`,
  ];

  useEffect(() => {
    dispatch(getCapitalPlanTableData({ assetPlanID: assetPlanId }));
    dispatch(getCapitalProjects({ assetPlanId: assetPlanId }));
    getGlAccountData('Turn Costs')
  }, [dispatch, assetPlanId, yearRangeSelected]);

  const getGlAccountData = async (grp_des: string) => {
    const request = {
      investment_Id: dapData?.investmentId,
      budget_Year: dapData?.budgetYear,
      group_Desc: grp_des
    }
    const response = await postApiCall(`${baseUrl}AssetPlan/GetCapitalPlanGL_Accounts`, request);
    setGlaccounts(prev => ({
      ...prev,
      [grp_des]: response
    }))
  }

  const toggleRowExpansion = (rowKey: string) => {
    getGlAccountData(rowKey)
    setExpandedRows(prev => ({
      ...prev,
      [rowKey]: !prev[rowKey]
    }));
  };

  const columnDataToRowData = () => {
    var projectedNoi: number = capitalPlanTableData[0]?.projectedNOI;

    capitalPlanTableData?.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        if (!rowWiseData[key]) {
          rowWiseData[key] = [];
        }

        rowWiseData[key].push(obj[key]);
      });
    });

    columns.forEach((name) => {
      var num = rowWiseData[name]?.at(0);
      if (num) {
        rowWiseData[name]?.splice(1, 0, (Number(num) / projectedNoi) * 100);
      }
    });

    capitalPlanTableData?.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        rowWiseData[key][0] = currency(rowWiseData[key][0]);
        rowWiseData[key][1] = numberWithComma(rowWiseData[key][1]);
      });
    });
  };
  columnDataToRowData();


  const formatDate = (dateString: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return `${months[date.getMonth()]}-${date.getDate()}-${date.getFullYear()}`;
  };

  const renderTableData = () => {
    return capitalProjectData?.map((val, i) => (
      <TableRow key={i}>
        <TableCell sx={{ width: "10%" }}>{val.projectPriority}</TableCell>
        <TableCell sx={{ width: "5%", textAlign: "center !important" }}>
          <Checkbox checked={val.esgImpact} disabled />
        </TableCell>
        <TableCell sx={{ width: "11%" }}>{val.projectId}</TableCell>
        <TableCell sx={{ width: "8.5%", textAlign: "right !important" }}>
          {currency(val.currentBudget)}
        </TableCell>
        <TableCell sx={{ width: "15.5%" }}>{val.projectDescription}</TableCell>
        <TableCell sx={{ width: "8%" }}>{val.projectStartDate ? formatDate(val.projectStartDate) : ""}</TableCell>
        <TableCell sx={{ width: "8%" }}>{val.projectEndDate ? formatDate(val.projectEndDate) : ""}</TableCell>
        <TableCell sx={{ width: "8%" }}>{val.methodOfFunding || ""}</TableCell>
        <TableCell sx={{ width: "8%" }}>{val.additiveToBookCost || ""}</TableCell>
        <TableCell sx={{ width: "20%" }}>{val.comment}</TableCell>
      </TableRow>
    ));
  };


  // const renderCapitalPlanTableData = () =>{

  // }
  const comments = useAppSelector((state) => state.dapComments?.data).find(
    (x) => x.commentKey.toLowerCase() === CommentKey.CAPITALPLAN.toLowerCase()
  );

  return (
    <div>
      <div className="tab-heading text-center">
        <h3 className="heading">Detailed Building Capital Plan</h3>
      </div>
      {capitalPlanTableDataStatus.loading ? (
        <Skeleton
          variant="rounded"
          width="100%"
          height={250}
          animation="wave"
        />
      ) : (
        <div className="responsive-table-wrapper">
          <table id="customers" className="responsive-table">
            <tr>
              <th>Project Priority</th>
              <th style={{ textAlign: "center" }}>{budgetYear <= 2024 ? `ESG Impact ` : `Contributes to SSBB feature`}</th>
              <th>Project ID</th>
              <th style={{ textAlign: "right" }}>{budgetYear} Budget</th>
              <th>Project Description</th>
              <th>Project Start</th>
              <th>Project End Date</th>
              <th>Method of Funding</th>
              <th>Additive to book cost</th>
              <th>Comments</th>
            </tr>

            <tbody>{renderTableData()}</tbody>
            {isNoData && (
              <TableRow>
                <TableCell colSpan={10} sx={{ textAlign: "center !important" }}>
                  No rows
                </TableCell>{" "}
              </TableRow>
            )}
          </table>
        </div>
      )}
      <br></br>
      <div className="tab-heading text-center">
        <h3 className="heading">Capital Plan </h3>
      </div>

      <div>
        {capitalPlanTableDataStatus.loading ? (
          <Skeleton
            variant="rounded"
            width="100%"
            height={250}
            animation="wave"
          />
        ) : (
          <table id="customers">
            <tr>
              <th></th>

              {columnNames
                ?.filter((_, i) => i < 2)
                .map((ele, index) => (
                  <th style={{ textAlign: "right" }} key={index}>
                    {ele}
                  </th>
                ))}
            </tr>
            <tbody>
              <tr>
                <th
                  className="grey-bg"
                  style={{ cursor: 'pointer', width: '700px' }}
                  onClick={() => toggleRowExpansion('BI Capital')}
                >
                  {expandedRows['BI Capital'] ? '▼' : '▶'} BI Capital
                </th>
                {rowWiseData.biCapital
                  ?.filter((_, i) => i < 2)
                  .map((ele, index) => (
                    <td style={{ textAlign: "right" }} key={index}>
                      {ele}
                    </td>
                  ))}
              </tr>
              {expandedRows['BI Capital'] && glAccounts?.['BI Capital'] && (
                <tr>
                  <td colSpan={2} style={{ padding: '0px' }}>
                    <table id="GLAccount" style={{ width: '100%' }}>
                      {glAccounts['BI Capital']?.map((account, index) => (
                        <tr key={index}>
                          <td style={{ width: '700px' }}>{account.account_Desc}</td>
                          <td style={{ textAlign: "right" }}>{currency(account.year1_budget)}</td>
                        </tr>
                      ))}
                    </table>
                  </td>
                </tr>
              )}
              <tr>
                <th
                  className="grey-bg"
                  style={{ cursor: 'pointer', width: '700px' }}
                  onClick={() => toggleRowExpansion('Leasing Cost')}
                >
                  {expandedRows['Leasing Cost'] ? '▼' : '▶'}Leasing Cost (Commercial)
                </th>
                {rowWiseData.leasingCostCommercial
                  ?.filter((_, i) => i < 2)
                  .map((ele, index) => (
                    <td style={{ textAlign: "right" }} key={index}>
                      {ele}
                    </td>
                  ))}
              </tr>
              {expandedRows['Leasing Cost'] && glAccounts?.['Leasing Cost'] && (
                <tr>
                  <td colSpan={2} style={{ padding: '0px' }}>
                    <table id="GLAccount" style={{ width: '100%' }}>
                      {glAccounts['Leasing Cost']?.map((account, index) => (
                        <tr key={index}>
                          <td style={{ width: '700px' }}>{account.account_Desc}</td>
                          <td style={{ textAlign: "right" }}>{currency(account.year1_budget)}</td>
                        </tr>
                      ))}
                    </table>
                  </td>
                </tr>
              )}
              <tr>
                <th
                  className="grey-bg"
                  style={{ cursor: 'pointer', width: '700px' }}
                  onClick={() => toggleRowExpansion('Turn Costs')}
                >
                  {expandedRows['Turn Costs'] ? '▼' : '▶'}Turn Cost (Residential)
                </th>
                {rowWiseData.turnCostResidential
                  ?.filter((_, i) => i < 2)
                  .map((ele, index) => (
                    <td style={{ textAlign: "right" }} key={index}>
                      {ele}
                    </td>
                  ))}
              </tr>
              {expandedRows['Turn Costs'] && rowWiseData.turnCostResidential &&(
                <tr>
                  <td colSpan={2} style={{ padding: '0px' }}>
                    <table id="GLAccount" style={{ width: '100%' }}>
                      <tr >
                        <td style={{ width: '700px' }}>Unit Rehab</td>
                        <td style={{ textAlign: "right" }}>{currency((Object.values(glAccounts?.['Turn Costs'] || {}).find((account: any) =>
                          account.account_Desc?.toLowerCase() === 'unit rehab'
                        ) as any)?.year1_budget) || '$0'}
                        </td>
                      </tr>
                      <tr >
                        <td style={{ width: '700px' }}>Unit Turn Cost</td>
                        <td style={{ textAlign: "right" }}>{currency((Object.values(glAccounts?.['Turn Costs'] || {}).find((account: any) =>
                          account.account_Desc?.toLowerCase() === 'unit turn cost'
                        ) as any)?.year1_budget) || '$0'}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              )}
              <tr>
                <th className="grey-bg">Total Capital</th>
                {rowWiseData.totalCapital
                  ?.filter((_, i) => i < 2)
                  .map((ele, index) => (
                    <td style={{ textAlign: "right" }} key={index}>
                      {ele}
                    </td>
                  ))}
              </tr>
              <tr>
                <th className="grey-bg">Projected NOI {budgetYear}</th>
                {rowWiseData.projectedNOI
                  ?.filter((_, i) => i < 2)
                  .map((ele, index) => (
                    <td style={{ textAlign: "right" }} key={index}>
                      {ele}
                    </td>
                  ))}
              </tr>
            </tbody>
          </table>
        )}
      </div>
      {capitalPlanTableDataStatus.error && (
        <GenericToast
          message={capitalPlanTableDataStatus.error}
          severity="error"
        />
      )}
      <form className="m-20 lease-form">
        <fieldset>
          <legend className="lease-title">Comments</legend>
          <FroalaEditorView model={comments?.commentText || ""} />
        </fieldset>
      </form>
    </div>
  );
};
